/**
 * Builds a URL query string (without the leading `?`) from an object of parameters.
 * Parameters whose value is `null` or `undefined` are left out, so optional parameters can be passed as-is;
 * other values are converted to strings and URL-encoded.
 *
 * @example
 * buildQueryString({ builderBrandId: 18, marketId: null, page: 1 }); // 'builderBrandId=18&page=1'
 *
 * @param {Object.<string, *>} parameters - The parameter names and values.
 * @returns {string} The encoded query string, or an empty string when no parameter has a value.
 */
const buildQueryString = (parameters) => new URLSearchParams(
  Object.entries(parameters ?? {}).filter(([, value]) => value !== null && value !== undefined),
).toString();

export default buildQueryString;
